import { alertActionsType } from '../../constants';

const error = (message) => {
    return { type: alertActionsType.ERROR, message };
}

const errorbo = (message) => {
    return { type: alertActionsType.ERRORBO, message };
}

const clear = () => {
    return { type: alertActionsType.CLEAR };
}

export const alertActions = {
    error,
    errorbo,
    clear
};